<template>
  <div class="rewardbox">
    <div class="rewardbox_title public"></div>
    <div class="rewarrules public">
      <div class="rewarrules_center">
        首次在任意赛区投稿可获得<span>小礼物*1</span>
      </div>
    </div>
    <div class="nav public" v-if="ism == 'PC'">
      <div :class="nav_upload" class="nav_staic public" @click="navClick(1)">
        上传作品
      </div>
      <div :class="nav_rules" class="nav_staic public" @click="navClick(2)">
        活动规则
      </div>
      <div :class="nav_works" class="nav_staic public" @click="navClick(3)">
        作品展示
      </div>
      <div :class="nav_top" class="nav_staic public" @click="navClick(4)">
        TOP
      </div>
    </div>
    <div class="mnav public" v-if="ism == 'M'" @click="navClick(4)"></div>
    <div class="rewardcenter">
      <div class="rewardcenter_top">
        <div class="rewardcenter_top_titlebox">
          <div class="rewardcenter_top_title public"></div>
          <div class="rewardcenter_top_rules public" @click="rulesClick"></div>
        </div>
        <div class="rewardcenter_top_listbox">
          <div
            class="rewardcenter_top_list public"
            v-for="item in prizeHeroList"
            :key="item.id"
          >
            <div
              class="rewardcenter_top_list_lable public"
              :class="item.titleclass"
            >
              <span>{{ item.title }}</span>
            </div>
            <img class="rewardcenter_top_img" :src="item.img" />
            <div class="rewardcenter_prizenamebox">
              <div class="rewardcenter_prizename">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rewardcenter_bottom">
        <div class="rewardcenter_bottom_titlebox">
          <div class="rewardcenter_bottom_title public"></div>
        </div>
        <div class="rewardcenter_top_listbox">
          <div
            class="rewardcenter_bottom_list public"
            v-for="item in prizeSoldiersList"
            :key="item.id"
          >
            <div
              class="rewardcenter_top_list_lable public"
              :class="item.titleclass"
            >
              <span>{{ item.title }}</span>
            </div>
            <img class="rewardcenter_top_img" :src="item.img" />
            <div class="rewardcenter_prizenamebox">
              <div class="rewardcenter_prizename">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "reward",
  props: {
    end: {
      type: String,
      default: "",
    },
    ism: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      lablered: "lablered",
      nav_upload: "nav_curbtn",
      nav_rules: "nav_btn",
      nav_works: "nav_btn",
      nav_top: "nav_topbtn",
      prizeHeroList: [
        {
          id: 0,
          titleclass: "lablered",
          title: "收录奖(1-2名）",
          img: require("@/assets/img/pc/prize/hero/included.png"),
          name: "5000现金+2333圣魔晶+ 同人团头像框",
        },
        {
          id: 1,
          titleclass: "",
          title: "一等奖（1名）",
          img: require("@/assets/img/pc/prize/hero/firstPrize.png"),
          name: "iPad +6666圣魔晶+ 同人团头像框",
        },
        {
          id: 2,
          titleclass: "",
          title: "二等奖（2名）",
          img: require("@/assets/img/pc/prize/hero/secondPrize.png"),
          name: "影拓手绘板+5555圣魔晶+ 同人团头像框",
        },
        {
          id: 3,
          titleclass: "",
          title: "三等奖（3名）",
          img: require("@/assets/img/pc/prize/hero/thirdPrize.png"),
          name: "雷蛇键鼠套装+2333圣魔晶+  同人团头像框",
        },
        {
          id: 4,
          titleclass: "",
          title: "优秀奖（5-10名）",
          img: require("@/assets/img/pc/prize/hero/goodPrize.png"),
          name: "888圣魔晶+泽瑞达手办1个+ 同人团头像框",
        },
        {
          id: 5,
          titleclass: "",
          title: "人气奖（5名）",
          img: require("@/assets/img/pc/prize/hero/popular.png"),
          name: "泽瑞达手办1个",
        },
      ],
      prizeSoldiersList: [
        {
          id: 0,
          titleclass: "lablered",
          title: "收录奖(1-2名）",
          img: require("@/assets/img/pc/prize/soldiers/included.png"),
          name: "2000现金+2333圣魔晶+  同人团头像框",
        },
        {
          id: 1,
          titleclass: "",
          title: "一等奖（1名）",
          img: require("@/assets/img/pc/prize/soldiers/firstPrize.png"),
          name: "5888圣魔晶+周边福袋+  同人团头像框",
        },
        {
          id: 2,
          titleclass: "",
          title: "二等奖（2名）",
          img: require("@/assets/img/pc/prize/soldiers/secondPrize.png"),
          name: "3888圣魔晶+周边福袋+  同人团头像框",
        },
        {
          id: 3,
          titleclass: "",
          title: "三等奖（3名）",
          img: require("@/assets/img/pc/prize/soldiers/thirdPrize.png"),
          name: "1888圣魔晶+周边福袋+  同人团头像框",
        },
        {
          id: 4,
          titleclass: "",
          title: "优秀奖（5-10名）",
          img: require("@/assets/img/pc/prize/soldiers/goodPrize.png"),
          name: "666圣魔晶+泽瑞达手办1个+  同人团头像框",
        },
        {
          id: 5,
          titleclass: "",
          title: "人气奖（5名）",
          img: require("@/assets/img/pc/prize/soldiers/popular.png"),
          name: "泽瑞达手办1个",
        },
      ],
    };
  },
  methods: {
    navClick(id) {
      switch (id) {
        case 1:
          this.nav_upload = "nav_curbtn";
          this.nav_rules = "nav_btn";
          this.nav_works = "nav_btn";
          this.nav_top = "nav_topbtn";
          this.$emit("tipchange", true, 4);
          break;
        case 2:
          this.nav_upload = "nav_btn";
          this.nav_rules = "nav_curbtn";
          this.nav_works = "nav_btn";
          this.nav_top = "nav_topbtn";
          this.$emit("tipchange", true, 2);
          break;
        case 3:
          this.nav_upload = "nav_btn";
          this.nav_rules = "nav_btn";
          this.nav_works = "nav_curbtn";
          this.nav_top = "nav_topbtn";
          if (this.end == "end") {
            window.scrollTo(100, 4850);
          } else {
            window.scrollTo(100, 3150);
          }
          break;
        case 4:
          this.nav_upload = "nav_btn";
          this.nav_rules = "nav_btn";
          this.nav_works = "nav_btn";
          this.nav_top = "nav_topcurbtn";
          window.scrollTo(100, 0);
          break;
      }
    },
    rulesClick() {
      this.$emit("tipchange", true, 2);
    },
  },
};
</script>
<style scoped>
</style>